import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ROADMAP } from "../content";
import { EASE, Reveal } from "../motion";
import { Section, Wrap, SectionHead } from "./Section";

export default function Roadmap() {
  const [open, setOpen] = useState(0);

  return (
    <Section id="delivery" theme="neutral" className="py-16 sm:py-24">
      <Wrap>
        <SectionHead
          eyebrow="Delivery roadmap"
          title="Ten weeks, six phases, clear decision gates."
          intro="The full target window is 8–12 weeks, depending on approvals, content complexity and stakeholder turnaround. Two contingency weeks protect the launch date."
        />

        <div className="mt-10 sm:mt-12" data-testid="roadmap">
          <div className="hidden md:block relative h-px bg-[#242424]/15 mb-14">
            <motion.span
              className="absolute left-0 top-0 h-px bg-[#B66E50] origin-left w-full"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 2, ease: "easeInOut" }}
            />
          </div>

          <ol className="grid md:grid-cols-6 gap-4">
            {ROADMAP.map((r, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={r.weeks} delay={i * 0.5}>
                  <li>
                    <button
                      data-testid={`roadmap-phase-${i + 1}`}
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      aria-expanded={isOpen}
                      className={`w-full text-left rounded-2xl border p-6 h-full transition-[background-color,border-color,transform] duration-400 cursor-pointer hover:-translate-y-1 ${
                        isOpen ? "bg-[#242424] border-[#242424] text-[#F5F3EE]" : "bg-white border-[#242424]/10 text-[#242424] hover:border-[#242424]/30"
                      }`}
                    >
                      <span className={`text-[9px] font-bold uppercase tracking-[0.2em] ${isOpen ? "text-[#FFD400]" : "text-[#B66E50]"}`}>{r.weeks}</span>
                      <span className="block font-serif text-lg leading-snug font-medium mt-3">{r.phase}</span>
                      <AnimatePresence initial={false}>
                        {isOpen && (
                          <motion.span
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.45, ease: EASE }}
                            className="block overflow-hidden"
                          >
                            <span className="block text-xs leading-relaxed text-[#F5F3EE]/70 mt-4">{r.deliverables}</span>
                            <span className="inline-block text-[9px] font-bold uppercase tracking-[0.18em] bg-[#FFD400] text-[#0F0F0F] px-3 py-1.5 rounded-full mt-4">
                              Gate · {r.gate}
                            </span>
                          </motion.span>
                        )}
                      </AnimatePresence>
                      {!isOpen && (
                        <span className="block text-[10px] font-semibold uppercase tracking-[0.16em] text-[#242424]/35 mt-4">
                          Tap for deliverables
                        </span>
                      )}
                    </button>
                  </li>
                </Reveal>
              );
            })}
          </ol>
        </div>
      </Wrap>
    </Section>
  );
}
